import { useQuery, UseQueryOptions } from 'react-query';

import { ChatSticker } from 'types/interfaces/chat/ChatSticker';

import { StickersApi } from 'api/StickersApi';

const STICKERS_QUERY_KEY = 'stickers-query';

export const useStickersQuery = (
  payload: { packId: number },
  queryOptions?: UseQueryOptions<ChatSticker[]>
) => {
  return useQuery<ChatSticker[]>(
    STICKERS_QUERY_KEY,
    () => StickersApi.fetchStickers(payload),
    {
      retry: false,
      ...queryOptions,
    }
  );
};
